<script lang="ts">
	import { CircleWithWarning, FoldButton } from "@hitit/new_ui";
	import { createEventDispatcher } from "svelte";
	import PlainTextEditor from "../../../components/place/PlainTextEditor.svelte";
	import sanitizeHtml from "sanitize-html";
	import { t } from "../../../stores";
	import { detectOverflow } from "../../utils";
	export let editmode = false;
	export let storedesc = "";

	const lengthLimit = 2000;
	const lineLimit = 100;

	let overflow = false;
	let openStoreDescription = false;

	$: textParse = sanitizeHtml(storedesc, {
		allowedTags: [],
		allowedAttributes: {},
	});

	const dispatch = createEventDispatcher();
	const overflowHandler = (__overflow: boolean) => (overflow = __overflow);
	function discriptionHandler(e: { detail: { html: string } }) {
		dispatch("UPDATE_STOREDESCRIPTION", {
			html: e.detail.html,
		});
	}

</script>

<div class="container">
	{#if editmode}
		<div class="editor">
			<PlainTextEditor
				placeholder={$t('hub.place.Enter_Your_Store_Description')}
				lengthLimit={lengthLimit}
				lineLimit={lineLimit}
				value={storedesc}
				on:UPDATE_TEXT={discriptionHandler} />
			<div class="text-length">{textParse.length}/{lengthLimit}</div>
		</div>
	{:else if storedesc}
		<div
			class:more={openStoreDescription}
			class="store-description"
			use:detectOverflow={[storedesc, overflowHandler, 100]}>
			{@html storedesc}
		</div>
		<div class="fold-button">
			{#if overflow}
				<FoldButton bind:fold={openStoreDescription}>
					<span
						class="fold-text">{openStoreDescription ? '접기' : '더보기'}</span>
				</FoldButton>
			{/if}
		</div>
	{:else}
		<p class="desc">
			<span class="store-warn">
				<CircleWithWarning />
			</span>
			{$t('hub.place.No_store_desc')}
		</p>
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.container {
		width: 100%;
		margin-top: 20px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.desc {
			display: flex;
			gap: 10px;
			font-size: 1.25rem;
			color: #46474b;
			.store-warn {
				width: 24px;
				height: 24px;
			}
		}

		.store-description {
			overflow-y: hidden;
			max-height: 110px;
			color: #46474b;
			width: calc(100% - 20px);
			line-height: 20px;
			text-align: center;
			word-break: break-all;

			&.more {
				max-height: none !important;
			}
		}
		.fold-button {
			margin-top: 20px;
			.fold-text {
				font-weight: 400;
				font-size: 0.75rem;
				color: #707070;
			}
		}
		.editor {
			width: calc(100% - 20px);
			max-width: 900px;

			:global(.plainTextEditor .ql-editor) {
				position: relative;
				text-align: center;
				box-sizing: border-box;
				border-style: none;
				border-radius: 13px;
				padding: 10px 14px;
				overflow: auto;
				background-color: #f0f0f4;
				line-height: 20px;
				color: #46474b;
			}
			:global(.plainTextEditor .ql-editor:focus) {
				outline: 0px solid transparent;
			}
			:global(.plainTextEditor .ql-editor.ql-blank::before) {
				color: #bcbfc3;
				content: attr(data-placeholder);
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
			}

			.text-length {
				width: 100%;
				color: #6d6f76;
				text-align: right;
				font-size: 0.875rem;
				margin-top: 6px;
			}
		}
	}

	@include DesktopSize {
		.container {
			margin-top: 24px;
			.store-description {
				max-height: 195px;
				font-size: 1.5rem;
				line-height: 35px;
				width: 63%;
			}

			.editor {
				width: 63%;
				:global(.plainTextEditor .ql-editor) {
					padding: 20px;
					font-size: 1.5rem;
					line-height: 35px;
				}

				:global(.plainTextEditor .ql-editor.ql-blank::before) {
					font-size: 1.5rem;
				}

				.text-length {
					margin-top: 10px;
					font-size: 1rem;
				}
			}

			.desc {
				font-size: 1.5625rem;
				.store-warn {
					width: 31px;
					height: 31px;
				}
			}

			.fold-button {
				margin-top: 10px;
				.fold-text {
					font-size: 1.25rem;
				}
			}
		}
	}

</style>
